<template>
  <v-sheet class="loadingContainer" color="white">
    <v-boilerplate type="list-item-avatar-two-line"></v-boilerplate>
    <v-divider></v-divider>
    <!-- Description -->
    <div class="pa-4">
      <v-boilerplate type="paragraph"></v-boilerplate>
      <v-boilerplate type="paragraph" class="flip-verticaly"></v-boilerplate>
      <v-boilerplate type="paragraph" class="mt-2"></v-boilerplate>
      <v-boilerplate type="paragraph"></v-boilerplate>
      <v-boilerplate
        type="heading"
        class="d-flex justify-end mt-4"
      ></v-boilerplate>
    </div>
    <v-divider></v-divider>
    <!-- Gems Chest -->
    <div class="pa-4">
      <v-boilerplate
        type="heading"
        class="d-flex justify-center"
      ></v-boilerplate>
      <!-- Gem list -->
      <div class="py-8">
        <v-boilerplate type="heading" class="my-4"></v-boilerplate>
        <v-boilerplate type="heading" class="my-4"></v-boilerplate>
      </div>
      <v-boilerplate
        type="heading"
        class="d-flex justify-center"
      ></v-boilerplate>
      <div class="pt-8">
        <v-boilerplate type="heading" class="my-4"></v-boilerplate>
        <v-boilerplate type="heading" class="my-4"></v-boilerplate>
        <v-boilerplate type="heading" class="my-4"></v-boilerplate>
      </div>
    </div>
  </v-sheet>
</template>

<script>
import { VSkeletonLoader } from "vuetify/lib";
export default {
  name: "TheAccountDisplayLoading",
  components: {
    // Create a new component that
    // extends v-skeleton-loader
    VBoilerplate: {
      functional: true,

      render(h, { data, props, children }) {
        return h(
          VSkeletonLoader,
          {
            ...data,
            props: {
              boilerplate: true,
              elevation: 0,
              ...props
            }
          },
          children
        );
      }
    }
  }
};
</script>

<style scoped>
.flip-verticaly {
  -webkit-transform: scaleY(-1);
  transform: scaleT(-1);
}
</style>
